"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCategoryDisplayText = void 0;
/**
 * Finds the cateogry display text in the config for a given typeahead category
 * @param config Config
 * @param category ValidTypeaheadCategory
 * @returns string
 */
function findCategoryDisplayText(config, category) {
    const result = config.params.typeahead_categories.find((typeaheadCategory) => {
        return typeaheadCategory.category === category;
    });
    return result ? result.display_text : '';
}
exports.findCategoryDisplayText = findCategoryDisplayText;
//# sourceMappingURL=findCategoryDisplayText.js.map